import { IsString, MaxLength } from "class-validator";
import { Constants } from "@eagerdog/constants";

import { PostType } from "./post.interface";
import { USER_CREATABLE_POST_TYPES } from "./create-post.dto";

/**
 * Post types whose text an author (or club manager) may edit after posting:
 * everything a user can create directly, plus the club's message on an
 * event_published post. Activity, title and result posts carry no user text.
 * EDIT_POST_PRD, Decision 1.
 */
export const EDITABLE_POST_TYPES: PostType[] = [
  ...USER_CREATABLE_POST_TYPES,
  Constants.post_type.event_published,
];

/** Text-only edit of an existing post. An empty string clears the caption. */
export class UpdatePostDto {
  @IsString()
  @MaxLength(2000)
  body!: string;
}
